// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Router from 'vue-router'
import './assets/scss/reset.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
// 引入axios 
// import axios from 'axios'; 
import http from './services/http' // 引入axios配置文件
import {http1} from './services/http' 
//引入富文本编辑器
// import '../static/UEditor/ueditor.config'
// import '../static/UEditor/ueditor.parse'

//引入icon样式
import "@icon-park/vue/styles/index.css"

// 挂载到vue原型链上 
Vue.prototype.$http = http;
Vue.prototype.$http1 = http1;
Vue.use(ElementUI)
Vue.use(Router)

Vue.config.productionTip = false
// router.beforeEach((to, from, next) => {
//   if (to.path == '/login') {
//       sessionStorage.removeItem('user');
//   }
//   let user = JSON.parse(sessionStorage.getItem('user'));
//   if (!user && to.path != '/login') {
//       next({
//           path: '/login'
//       });
//   } else {
//       next();
//   }
// });
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, // 注入到根实例中
  render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js